module.exports = __webpack_public_path__ + "img/paciente.d1fc2539.jpg";